import { createContext } from "react";
import { Theme } from "@fluentui/react-components";
import { PlatformContext } from "../services/platformContext";

export const TeamsFxContext = createContext<{
  theme?: Theme;
  themeString: string;
  teamsUserCredential?: any;
  platformContext?: PlatformContext;
}>({
  theme: undefined,
  themeString: "",
  teamsUserCredential: undefined,
  platformContext: undefined,
});
